// WishLists.js
import React from 'react';

const WishLists = () => {
  return (
    <div>
      <h2>Wish Lists</h2>
      <p>Manage your wish lists here.</p>
     
    </div>
  );
};

export default WishLists;
